module.exports = __webpack_public_path__ + "media/images/faces/face13-4d05b521a27a2993503567f71dff8504.jpg";